<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input icon="fa fa-search fa-fw" placeholder="Pesquisar..." v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-primary" @click="incluir()">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'A'">
                                Ativos
                            </button>
                            <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2" v-if="exibicao && exibicao.length">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>    

        <div class="mb-3" v-else>
        </div>

        <az-empty-state 
            v-if="!exibicao || !exibicao.length" 
            msg="Nenhum usuário delegado identificado." />

        <template v-else>
            <table class="table bg-white">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Delegado Para</th>
                        <th>Em</th>
                        <th>De</th>
                        <th>Até</th>
                        <th>Motivo/Observações</th>
                        <th width="1%"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(delegado, idx) in exibicao" :key="idx" :class="!delegado.fl_ativo ? 'table-secondary' : ''">
                        <td class="text-nowrap">
                            <a href="#" @click.prevent="editar(delegado)" class="card-link">
                                #{{ delegado.id_delegacao }}
                            </a>
                        </td>
                        <td class="text-nowrap">
                            {{ delegado.delegado.pessoa.st_nome }}
                            <span class="small text-muted ml-2">
                                ({{ delegado.delegado.st_login }})
                            </span>
                        </td>
                        <td>{{ $util.getFormatDate(delegado.created_at) }}</td>
                        <td>{{ $util.getFormatDate(delegado.dt_vigencia_inicio) }}</td>
                        <td>{{ $util.getFormatDate(delegado.dt_vigencia_termino) }}</td>
                        <td>{{ delegado.st_observacoes }}</td>
                        <td>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + idx" 
                                    v-model="delegado.fl_ativo" 
                                    @change="toggle(delegado)">
                                <label class="custom-control-label" :for="'ativo-' + idx"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <pre v-if="false">{{ lista }}</pre>
        </template>

        <!-- Delegar Para -->
        <div class="modal fade" id="delegacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Delegar Para
                            <span class="badge badge-secondary ml-3" v-if="edicao.id_delegacao">
                                #{{ edicao.id_delegacao }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Delegado para"
                                    placeholder="Selecione o usuário..."
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    :optionsParm="{ ativos: true }"
                                    service="usuarios.index"
                                    v-model="edicao.delegado"
                                    required
                                    :validate="validate"
                                    :edicao="!edicao.id_delegacao"
                                    ref="info_usuario" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    type="date"
                                    label="De"
                                    required
                                    :validate="validate"
                                    :edicao="!edicao.id_delegacao"
                                    v-model="edicao.dt_vigencia_inicio" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    type="date"
                                    label="Até"
                                    required
                                    :validate="validate"
                                    :edicao="!edicao.id_delegacao"
                                    v-model="edicao.dt_vigencia_termino" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input   
                                    type="textarea"
                                    rows="3"
                                    label="Motivo/Observações"
                                    :edicao="!edicao.id_delegacao"
                                    v-model="edicao.st_observacoes" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="delegacao" :id="edicao.id_delegacao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()" v-if="!edicao.id_delegacao">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzPeriodo from './forms/AzPeriodo.vue';
import AzInput from './forms/AzInput.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import AzSubmit from '../util/AzSubmit.vue';
import AzAuditLogButton from '../util/AzAuditLogButton.vue';

export default {
    data() {
        return { 
            filtro: { 
                ativos: true,
                periodo: 'h',
                search: ""
            },
            edicao: null, 
            validate: false, 
            lista: [], 
            viewMode: 'A', 
        }
    },

    components: { 
        AzEmptyState,
        AzPeriodo,
        AzInput, 
        AzSubmit,
        AzAuditLogButton, 
    },

    computed: { 
        exibicao: function () { 
            if ( !this.lista ) { 
                return [];
            }

            let reg = this.$util.getregex(this.filtro.search);

            return this.lista.filter(item => ( this.viewMode == 'T' || item.fl_ativo ) && ( !this.filtro.search || reg.test(JSON.stringify(item)) ));
        }
    },

    methods: { 
        incluir () { 
            this.validate = false;
            this.edicao = { 
                id_delegacao: null, 
                st_tipo: 'P', 
                id_usuario_delegado: "", 
                dt_vigencia_inicio: this.$util.hoje(), 
                dt_vigencia_termino: "", 
                st_observacoes: "", 
                delegado: "", 
            };

            
            $('#delegacaoModal').modal('show');
        },

        editar (item) { 
            this.validate = false;
            this.edicao = _.cloneDeep(item);

            $('#delegacaoModal').modal('show');
        },

        load() {
            this.$util.load(this, { 
                service: 'delegacoes',
                parms: this.filtro,
                loadTo: res => { 
                    this.lista = res;
                }
            });
        },

        atualizar() { 
            this.edicao.id_usuario_delegado = _.get(this.edicao, 'delegado.id_usuario');

            this.$util.atualizar(this, { 
                service: 'delegacoes',
                dados: this.edicao,
                modal: 'delegacaoModal', 
                reload: true, 
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'delegacoes',
                dados: item,
            });

        },
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Delegação", path: "/delegacao" }
        ]);

        this.load();
    }
}
</script>
